import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from "sweetalert2";

import config from "../../config";
import { useNetworkState } from "react-use";
import Moment from "react-moment";
// import PasswordProtectionModal from './PasswordProtectionModal';

const Header_nav = () => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedSection, setSelectedSection] = React.useState("");
  const [redirectUrl, setRedirectUrl] = React.useState("");
  const [announcementstate, setannouncementstate] = React.useState([]);
  const [privacy, setPrivacy] = React.useState({});
  const user = JSON.parse(localStorage.getItem("ship_rocket_user"));
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  const [balancestate, setbalanceState] = React.useState({ total_balance: [] });
  const [dimensionState, setdimensionState] = React.useState({
    companyDetail: [],
  });
  const [userState, setUserState] = React.useState({ full_name: "" });
  const [trackstate, settrackState] = React.useState({ awb: "" });
  const [amndrstate, setamndrstate] = React.useState({
    am_output: [],
    ndr_output: [],
    relation_manager: false,
  });
  const [searchstate, setsearch] = React.useState({ search: "" });
  const [log, setlog] = React.useState({ order_log: {}, shipment_log: {} });
  console.log("log ==", log);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [searchHistory, setSearchHistory] = React.useState(
    JSON.parse(localStorage.getItem("searchHistory")) || [] // default to empty array if no history found
  );
  const [isSearchBoxVisible, setIsSearchBoxVisible] = React.useState(false);
  const [readState, setreadState] = React.useState(false);
  const [showKycModal, setShowKycModal] = React.useState(false);

  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  React.useEffect(() => {
    get_wallet_balance();
    dimension_detail();
    // user()
  }, []);
  React.useEffect(() => {
    const sidebar = document.querySelector(".sidebar-wrapper");
    const pageWrapper = document.querySelector(".page-wrapper");

    const addHover = () => pageWrapper?.classList.add("sidebar-hovered");
    const removeHover = () => pageWrapper?.classList.remove("sidebar-hovered");

    if (sidebar && pageWrapper) {
      sidebar.addEventListener("mouseenter", addHover);
      sidebar.addEventListener("mouseleave", removeHover);
    }

    return () => {
      if (sidebar && pageWrapper) {
        sidebar.removeEventListener("mouseenter", addHover);
        sidebar.removeEventListener("mouseleave", removeHover);
      }
    };
  }, []);

  const get_wallet_balance = () => {
    let dataToSend = { customer_id: userData.customer_id };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/get_customer_wallet";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          setbalanceState({ total_balance: res.data.find_customer_wallet });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };
  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setdimensionState({
          ...dimensionState,
          companyDetail: res.data.companyDetail,
        });
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  const ndr_detail = () => {
    let full_api = config.apiUrl + `/shipment/unread_ndr`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setreadState(res.data.show_popup);
      })
      .catch((e) => {});
  };

  React.useEffect(() => {
    // Fetch protected sections from backend
    axios
      .post(
        `${config.apiUrl}/user/privacy_settings`,
        { customer_id: user.customer_id },
        { headers: config.headers }
      )
      .then((res) => {
        if (res.data?.protected_sections) {
          const protectedMap = res.data.protected_sections.reduce(
            (acc, cur) => {
              acc[cur] = true;
              return acc;
            },
            {}
          );
          setPrivacy(protectedMap);
        }
      });
  }, []);
  const handleProtectedClick = (section, url) => {
    // First check if we have recent verification
    if (privacy[section]) {
      setSelectedSection(section);
      setRedirectUrl(url);
      setModalVisible(true);
    } else {
      window.location.href = url;
    }
  };

  const handleSuccess = () => {
    window.location.href = redirectUrl;
  };

  React.useEffect(() => {
    log_detail();
    customerDetail();
    ndr_detail();
  }, []);
  const log_detail = () => {
    let full_api = config.apiUrl + `/shipment/logs_detail`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setlog({
          order_log: res.data.order_log,
          shipment_log: res.data.shipment_log,
        });
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };
  const logOutButton = async () => {
    console.log("🔥 logOutButton called");

    const userDetail = localStorage.getItem("ship_rocket_user");

    let userData = {};

    try {
      userData = userDetail ? JSON.parse(userDetail) : {};
    } catch (error) {
      console.error("Invalid user data:", error);
    }

    console.log("🔥 logout userData =>", userData);

    try {
      const full_api = `${config.apiUrl}/user/user_logout`;

      const sendData = {
        customer_id: userData?.customer_id || "",
      };

      console.log("🔥 logout request =>", full_api, sendData);

      const res = await axios.post(full_api, sendData, {
        headers: config.headers,
      });

      console.log("🔥 logout response =>", res.data);

      if (res.data?.status === true) {
        console.log("🔥 LOGOUT SUCCESS");

        localStorage.removeItem("ship_rocket_user");

        localStorage.removeItem("searchHistory");

        localStorage.removeItem("kyc_checked");

        localStorage.removeItem("global_shipping_task");

        setUserMenuOpen(false);

        setUserState({
          full_name: "",
        });

        console.log(
          "🔥 localStorage user =>",
          localStorage.getItem("ship_rocket_user")
        );

        navigate("/login", {
          replace: true,
        });

        setTimeout(() => {
          window.location.replace("/login");
        }, 50);
      } else {
        console.error("Logout API returned false:", res.data);

        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "error",
          title: res.data?.message || "Logout failed.",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("🔥 LOGOUT ERROR:", error);

      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "error",
        title:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to logout.",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };

  // const handlechnage=(e)=>{
  //  settrackState({...trackstate , awb:e.target.value})
  // }

  const searchchange = (e) => {
    setsearch({ search: e.target.value });
  };

  const shipmentpage = () => {
    window.location.href = `/shipments?number=${searchstate.search}`;
  };

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Cmd/Ctrl + K
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault(); // Prevent the default browser action
        setIsSearchBoxVisible((prevState) => !prevState); // Toggle search box visibility
      }
    };

    // Attach the event listener
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Handle Search Input Change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle Search (Enter key)
  const handleSearchSubmit = (e) => {
    if (e.key === "Enter" && searchQuery.trim()) {
      const updatedHistory = [searchQuery, ...searchHistory].slice(0, 5);
      setSearchHistory(updatedHistory);

      // Save to localStorage
      localStorage.setItem("searchHistory", JSON.stringify(updatedHistory));

      // Navigate to the shipments page
      window.location.href = `/shipments?number=${encodeURIComponent(
        searchQuery
      )}`;

      // Clear the search query
      setSearchQuery("");
    }
  };
  // Handle Search from History Item Click
  const handleHistoryClick = (searchTerm) => {
    setSearchQuery(searchTerm);
    setIsSearchBoxVisible(false); // Close search box when a history item is clicked
  };

  const customerDetail = () => {
    let full_api = config.apiUrl + `/user/am_ndr_detail`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setamndrstate({
          am_output: res.data.am_output,
          ndr_output: res.data.ndr_output,
          relation_manager: res.data.relation_manager,
        });
      })
      .catch((e) => {});
  };
  React.useEffect(() => {
    // let kycChecked = localStorage.getItem("kyc_checked");
    // console.log("kycChecked == " , kycChecked)
    let url = config.apiUrl + "/user/find_customer_detail";
    let dataToSend = {};
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        console.log("res ===", res.data.output);
        if (res.data.output && res.data.output.kyc == true) {
          setShowKycModal(true);
          // localStorage.setItem("kyc_checked", "true"); // Prevent showing it again
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const assign_function = () => {
    let url = config.apiUrl + "/user/assign_mail_for_relationship_manager";
    let dataToSend = { customer_id: userData.customer_id };
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        if (res.data.status == true) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  React.useEffect(() => {
    announcement();
  }, []);
  const announcement = () => {
    let dataToSend = {};

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/get_announcement";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        if (res.data.status == true) {
          setannouncementstate(res.data.output);
        } else {
        }
      })

      .catch((error) => {});
  };

  React.useEffect(() => {
    const logoutButton = document.getElementById("logoutButton");

    if (!logoutButton) {
      console.log("❌ logoutButton not found");
      return;
    }

    const handleLogout = (e) => {
      e.preventDefault();
      e.stopPropagation();

      console.log("🔥 NATIVE LOGOUT CLICK");

      logOutButton();
    };

    logoutButton.addEventListener("click", handleLogout);

    return () => {
      logoutButton.removeEventListener("click", handleLogout);
    };
  }, []);
  return (
    <div>
      <div class="topbar">
        <button
          class="tb-menu-btn"
          id="tbMenuBtn"
          title="Menu"
          aria-label="Open menu"
        >
          <i class="bi bi-list"></i>
        </button>
        <div class="breadcrumb-bar">
          <i class="bi bi-grid" style={{ fontSize: "14px" }}></i>
          <span>Dashboard</span>
          <span style={{ color: "#d1d5db" }}>/</span>
          <span class="cur">Overview</span>
        </div>
        <form
          class="tb-search"
          id="tbSearch"
          action="/orders"
          method="get"
          autocomplete="off"
        >
          <div class="tb-search-wrap">
            <i class="bi bi-search tb-search-ic"></i>
            <input
              type="text"
              name="q"
              id="tbSearchInput"
              placeholder="Search AWB No."
              spellcheck="false"
            />
            <input type="hidden" name="type" id="tbSearchType" value="awb" />
            <button type="button" class="tb-search-type" id="tbSearchTypeBtn">
              <span id="tbSearchTypeLbl">AWB No.</span>
              <i class="bi bi-chevron-down"></i>
            </button>
            <ul class="tb-search-menu" id="tbSearchMenu">
              <li data-type="awb" class="on">
                AWB No.
              </li>
              <li data-type="order">Order No.</li>
              <li data-type="ref">Ref. No.</li>
              <li data-type="mobile">Mobile No.</li>
              <li data-type="email">Email</li>
              <li data-type="name">Name</li>
            </ul>
          </div>
        </form>
        <div class="tb-right">
          <div class="wallet-chip">
            <i class="bi bi-wallet2"></i>
            <span class="wallet-amount">
              &#8377;
              {balancestate.total_balance.map((sub) =>
                parseFloat(sub.wallet_balance).toFixed(2)
              )}
            </span>
            <span class="wallet-arrow">
              <i class="bi bi-chevron-down"></i>
            </span>
          </div>
          <button
            class="ib tb-wallet-refresh"
            id="walletRefresh"
            title="Refresh wallet balance"
          >
            <i class="bi bi-arrow-clockwise"></i>
          </button>
          <a
            href="/recharge_wallet"
            class="tb-recharge"
            title="Recharge Wallet"
          >
            <i class="bi bi-plus-lg"></i> Recharge
          </a>
          <a href="/support_tickets" class="tb-support" title="Support Ticket">
            <i class="bi bi-headset"></i>
            <span>Support</span>
          </a>
          <button class="qa-btn" id="quickActionsBtn" title="Quick Actions">
            <i class="bi bi-lightning-charge"></i> Quick Actions
          </button>
          <div class="qa-mega" id="qaMega">
            <div class="qa-title">Quick Actions</div>
            <div class="qa-grid">
              <a href="/rate_calculator" class="qa-card">
                <i class="bi bi-calculator"></i>
                <span>Rate Calculator</span>
              </a>
              <a href="/create_order" class="qa-card">
                <i class="bi bi-plus-circle"></i>
                <span>Add Order</span>
              </a>
              {/* <a href="/tracking" class="qa-card">
                <i class="bi bi-radar"></i>
                <span>Track Order</span>
              </a> */}
              <a href="/create_order?view=bulk" class="qa-card">
                <i class="bi bi-cloud-arrow-up"></i>
                <span>Import Order</span>
              </a>
            </div>
          </div>
          <div class="ib" id="themeToggle" title="Toggle theme">
            <i class="bi bi-moon-stars"></i>
          </div>
          <div class="ib">
            <a href="/settings">
              {" "}
              <i class="bi bi-gear"></i>
            </a>
          </div>
          <div class="tb-user" id="userDropdown">
            <div class="tb-av">JD</div>
            <div class="tb-dropdown" id="userMenu">
              <a href="/profile_update">
                <i class="bi bi-person"></i> Profile
              </a>
              <a href="/bank_details">
                <i class="bi bi-bank"></i> Bank Details
              </a>
              <a href="/kyc">
                <i class="bi bi-person-vcard"></i> KYC Detail
              </a>
              <a href="/billing_address">
                <i class="bi bi-cash"></i> Billing Detail
              </a>
              <a href="/change_password">
                <i class="bi bi-person-lock"></i> Change Password
              </a>
              <div class="tb-divider"></div>
              {/* <a href="/email_notification">
                <i class="bi bi-envelope-at"></i> Email Notification
              </a> */}
              {/* <a href="/sms_notification">
                <i class="bi bi-phone"></i> SMS Notification
              </a> */}
              {/* <a href="/whatsapp_notification">
                <i class="bi bi-whatsapp"></i> Whatsapp Notification
              </a> */}
              <div class="tb-divider"></div>
              <a type="button" id="logoutButton">
                <i className="bi bi-box-arrow-right"></i>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header_nav;
